export default function App() {
  return (
    <div style={{ padding: "40px", fontFamily: "Arial" }}>
      <h1>🚀 Hola Mundo</h1>
      <p>Desplegado desde CodeSandbox a Cloudflare Pages.</p>
    </div>
  );
}
